/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue } from './GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue';
import {
    GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSON,
    GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSONTyped,
    GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSON,
    GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSONTyped,
} from './GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue';

/**
 * 
 * @export
 * @interface UpdateStorefrontCheckoutConfigRequest
 */
export interface UpdateStorefrontCheckoutConfigRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStorefrontCheckoutConfigRequest
     */
    askForCutlery: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStorefrontCheckoutConfigRequest
     */
    allowTips: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStorefrontCheckoutConfigRequest
     */
    hideTipsUntilUserAction: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateStorefrontCheckoutConfigRequest
     */
    tipPresets: Array<number>;
    /**
     * 
     * @type {{ [key: string]: GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue; }}
     * @memberof UpdateStorefrontCheckoutConfigRequest
     */
    paymentMethods: { [key: string]: GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue; };
}

/**
 * Check if a given object implements the UpdateStorefrontCheckoutConfigRequest interface.
 */
export function instanceOfUpdateStorefrontCheckoutConfigRequest(value: object): value is UpdateStorefrontCheckoutConfigRequest {
    if (!('askForCutlery' in value) || value['askForCutlery'] === undefined) return false;
    if (!('allowTips' in value) || value['allowTips'] === undefined) return false;
    if (!('hideTipsUntilUserAction' in value) || value['hideTipsUntilUserAction'] === undefined) return false;
    if (!('tipPresets' in value) || value['tipPresets'] === undefined) return false;
    if (!('paymentMethods' in value) || value['paymentMethods'] === undefined) return false;
    return true;
}

export function UpdateStorefrontCheckoutConfigRequestFromJSON(json: any): UpdateStorefrontCheckoutConfigRequest {
    return UpdateStorefrontCheckoutConfigRequestFromJSONTyped(json, false);
}

export function UpdateStorefrontCheckoutConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStorefrontCheckoutConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'askForCutlery': json['askForCutlery'],
        'allowTips': json['allowTips'],
        'hideTipsUntilUserAction': json['hideTipsUntilUserAction'],
        'tipPresets': json['tipPresets'],
        'paymentMethods': (mapValues(json['paymentMethods'], GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSON)),
    };
}

export function UpdateStorefrontCheckoutConfigRequestToJSON(json: any): UpdateStorefrontCheckoutConfigRequest {
    return UpdateStorefrontCheckoutConfigRequestToJSONTyped(json, false);
}

export function UpdateStorefrontCheckoutConfigRequestToJSONTyped(value?: UpdateStorefrontCheckoutConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'askForCutlery': value['askForCutlery'],
        'allowTips': value['allowTips'],
        'hideTipsUntilUserAction': value['hideTipsUntilUserAction'],
        'tipPresets': value['tipPresets'],
        'paymentMethods': (mapValues(value['paymentMethods'], GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSON)),
    };
}

